import React from 'react';

const Bar = ({
  title,
  percentage,
  current,
  total,
  color,
  unit = '',
  duration = 700,
}) => {
  return (
    <div>
      <div className='flex justify-between text-xs mb-1'>
        <span className='text-white'>{title}</span>
        <span className='text-gray-400'>
          {current} / {total} {unit}
        </span>
      </div>
      <div className='h-1.5 bg-neutral-800 rounded-full overflow-hidden'>
        <div
          className={`h-full rounded-full transition-all duration-${duration} ease-in-out`}
          style={{ width: `${percentage}%`, backgroundColor: color }}
        />
      </div>
    </div>
  );
};

export default Bar;
